import { useEffect, useState } from 'react';

import { useUtilityContext } from '@change-corgi/core-react/utilityContext';

import { subscribeToSupporterPresence } from '#src/app/pages/psf/share/shared/utils';
import { isAndroidPhone } from '#src/app/shared/utils/userAgent';

/**
 * Whether the supporter can see the page, i.e. hasn't switched to another app or tab (see
 * `subscribeToSupporterPresence`, which the post-share redirect waits on too).
 */
export function useIsPageVisible(): boolean {
	const utilityContext = useUtilityContext();
	const settleOnReturn = isAndroidPhone(utilityContext);
	const [isVisible, setIsVisible] = useState(true);

	useEffect(() => subscribeToSupporterPresence(setIsVisible, { settleOnReturn }), [settleOnReturn]);

	return isVisible;
}
